<div class="min-h-screen w-full overflow-auto relative">
  <!-- Background image with fixed position to ensure full coverage -->
  <div class="absolute inset-0 z-0 h-full w-full">
    <img
      src="assets/images/coming-soon.png"
      alt="Background"
      class="object-cover w-full h-full min-h-screen"
    />
    <!-- Darker black overlay for better readability -->
    <div class="absolute inset-0 bg-black/50"></div>
  </div>

  <!-- Main content -->
  <div class="relative z-10 flex flex-col min-h-screen w-full">
    <!-- Header with Logo -->
    <div class="flex justify-start p-4 sm:p-5 md:p-6">
      <img
        src="assets/images/logo.png"
        alt="CleverDeals Logo"
        class="h-10 sm:h-12 md:h-14"
      />
    </div>

    <!-- Main content area -->
    <div class="flex-grow flex flex-col md:flex-row items-center">
      <!-- Left Content -->
      <div
        class="w-full md:w-1/2 px-5 py-6 sm:px-8 md:px-10 lg:px-16 flex flex-col justify-center"
      >
        <h2
          class="text-lg sm:text-xl md:text-2xl font-bold text-white mb-2 md:mb-3 leading-tight drop-shadow-lg"
        >
          TOGETHER We Get the Best Deals!
        </h2>

        <p class="text-white mb-3 md:mb-4 drop-shadow text-xs sm:text-sm">
          Our First Deal will Launch on Monday 7th April 2025 at 10am UK time
        </p>

        <!-- Launch countdown with improved responsive styling -->
        <div
          class="flex space-x-2 sm:space-x-3 mb-6 md:mb-8 justify-center md:justify-start"
        >
          <div
            class="countdown-box w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 bg-white rounded-lg flex flex-col items-center justify-center shadow-lg"
          >
            <div
              class="countdown-value text-xl sm:text-2xl md:text-3xl font-bold text-[#FF5858]"
            >
              {{ countdownDays }}
            </div>
            <div class="countdown-label text-xs sm:text-sm text-gray-600">
              DAYS
            </div>
          </div>
          <div
            class="countdown-box w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 bg-white rounded-lg flex flex-col items-center justify-center shadow-lg"
          >
            <div
              class="countdown-value text-xl sm:text-2xl md:text-3xl font-bold text-[#FF5858]"
            >
              {{ countdownHours }}
            </div>
            <div class="countdown-label text-xs sm:text-sm text-gray-600">
              HOURS
            </div>
          </div>
          <div
            class="countdown-box w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 bg-white rounded-lg flex flex-col items-center justify-center shadow-lg"
          >
            <div
              class="countdown-value text-xl sm:text-2xl md:text-3xl font-bold text-[#FF5858]"
            >
              {{ countdownMinutes }}
            </div>
            <div class="countdown-label text-xs sm:text-sm text-gray-600">
              MINS
            </div>
          </div>
          <div
            class="countdown-box w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 bg-white rounded-lg flex flex-col items-center justify-center shadow-lg"
          >
            <div
              class="countdown-value text-xl sm:text-2xl md:text-3xl font-bold text-[#FF5858]"
            >
              {{ countdownSeconds }}
            </div>
            <div class="countdown-label text-xs sm:text-sm text-gray-600">
              SECS
            </div>
          </div>
        </div>
      </div>

      <!-- Right Form Content -->
      <div
        class="w-full md:w-1/2 px-5 py-6 sm:px-8 md:px-10 lg:px-16 flex justify-center"
      >
        <div class="w-full max-w-md lg:max-w-lg">
          <!-- Registration Form Section with slightly larger styling -->
          <div
            *ngIf="!registered"
            class="bg-white p-4 sm:p-5 md:p-6 rounded-lg shadow-lg border border-gray-100"
          >
            <p
              class="text-center font-medium text-gray-800 mb-3 sm:mb-4 text-sm sm:text-base"
            >
              Register now and become one of our Founding Members
            </p>

            <form
              [formGroup]="registrationForm"
              (ngSubmit)="onRegister()"
              class="space-y-2 sm:space-y-3"
            >
              <!-- First and Last Name - stack on small mobile, side by side on larger devices -->
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3">
                <div>
                  <label class="block text-gray-700 mb-1 text-xs sm:text-sm"
                    >First Name</label
                  >
                  <input
                    type="text"
                    formControlName="firstName"
                    class="w-full px-2 py-1 sm:px-3 sm:py-2 bg-gray-50 text-gray-800 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#F09819] focus:border-[#F09819] text-xs sm:text-sm"
                    placeholder="Enter first name"
                  />
                  <div
                    *ngIf="
                      registrationForm.get('firstName')?.touched &&
                      registrationForm.get('firstName')?.invalid
                    "
                    class="text-red-500 text-xxs mt-1"
                  >
                    {{
                      getErrorMessage(
                        registrationForm.get("firstName"),
                        "First name"
                      )
                    }}
                  </div>
                </div>
                <div>
                  <label class="block text-gray-700 mb-1 text-xs sm:text-sm"
                    >Last Name</label
                  >
                  <input
                    type="text"
                    formControlName="lastName"
                    class="w-full px-2 py-1 sm:px-3 sm:py-2 bg-gray-50 text-gray-800 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#F09819] focus:border-[#F09819] text-xs sm:text-sm"
                    placeholder="Enter last name"
                  />
                  <div
                    *ngIf="
                      registrationForm.get('lastName')?.touched &&
                      registrationForm.get('lastName')?.invalid
                    "
                    class="text-red-500 text-xxs mt-1"
                  >
                    {{
                      getErrorMessage(
                        registrationForm.get("lastName"),
                        "Last name"
                      )
                    }}
                  </div>
                </div>
              </div>

              <!-- Email Input -->
              <div>
                <label class="block text-gray-700 mb-1 text-xs sm:text-sm"
                  >Email</label
                >
                <input
                  type="email"
                  formControlName="email"
                  class="w-full px-2 py-1 sm:px-3 sm:py-2 bg-gray-50 text-gray-800 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#F09819] focus:border-[#F09819] text-xs sm:text-sm"
                  placeholder="Enter your email"
                />
                <div
                  *ngIf="
                    registrationForm.get('email')?.touched &&
                    registrationForm.get('email')?.invalid
                  "
                  class="text-red-500 text-xxs mt-1"
                >
                  {{ getErrorMessage(registrationForm.get("email"), "Email") }}
                </div>
              </div>

              <!-- Password Input -->
              <div class="hidden">
                <label class="block text-gray-700 mb-1 text-xs sm:text-sm"
                  >Password</label
                >
                <input
                  type="password"
                  formControlName="password"
                  class="w-full px-2 py-1 sm:px-3 sm:py-2 bg-gray-50 text-gray-800 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#F09819] focus:border-[#F09819] text-xs sm:text-sm"
                  placeholder="Create a password"
                />
                <div
                  *ngIf="
                    registrationForm.get('password')?.touched &&
                    registrationForm.get('password')?.invalid
                  "
                  class="text-red-500 text-xxs mt-1"
                >
                  {{
                    getErrorMessage(
                      registrationForm.get("password"),
                      "Password"
                    )
                  }}
                </div>
              </div>

              <!-- Register Button -->
              <button
                type="submit"
                class="w-full py-2 sm:py-3 font-medium text-black rounded-md bg-gradient-to-r from-[#F9CC0B] to-[#FFE97F] hover:from-[#F0C400] hover:to-[#FFE066] transition-all flex items-center justify-center gap-2 mt-3 sm:mt-4 text-sm sm:text-base"
                [disabled]="isLoading"
              >
                <ng-container *ngIf="isLoading; else registerText">
                  Register Now <i class="fas fa-spinner fa-spin"></i>
                </ng-container>
                <ng-template #registerText> Register Now </ng-template>
              </button>
            </form>

            <!-- Divider -->
            <div class="relative my-2 sm:my-3">
              <div class="absolute inset-0 flex items-center">
                <div class="w-full border-t border-gray-200"></div>
              </div>
              <div class="relative flex justify-center text-xxs sm:text-xs">
                <span class="px-2 bg-white text-gray-500"
                  >Or register with</span
                >
              </div>
            </div>

            <!-- Social Registration Buttons -->
            <div class="flex justify-center space-x-3">
              <button
                type="button"
                (click)="signUpWithGoogle()"
                class="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-full transition-all"
              >
                <i class="fab fa-google text-sm sm:text-base"></i>
              </button>

              <button
                type="button"
                (click)="signInWithFacebook()"
                class="hidden flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-full transition-all"
              >
                <i class="fab fa-facebook text-sm sm:text-base"></i>
              </button>
            </div>
          </div>

          <!-- Success Message After Registration with slightly larger styling -->
          <div
            *ngIf="registered"
            class="bg-white p-4 sm:p-5 md:p-6 rounded-lg shadow-lg border border-gray-100 text-center"
          >
            <div class="mb-2 sm:mb-3">
              <div
                class="mx-auto w-10 h-10 sm:w-12 sm:h-12 bg-green-100 rounded-full flex items-center justify-center"
              >
                <i class="fas fa-check text-green-500 text-lg"></i>
              </div>
            </div>

            <h3
              class="text-base sm:text-lg font-bold text-gray-800 mb-1 sm:mb-2"
            >
              Congratulations on your registration!
            </h3>

            <p class="text-xs sm:text-sm text-gray-600 mb-2 sm:mb-3">
              We'll keep you updated and let you know as soon as the deals goes
              live. In the meantime, spread the word!
            </p>

            <!-- Social Sharing Buttons with branded colors -->
            <div class="flex justify-center space-x-2 sm:space-x-3 mb-2">
              <button
                (click)="shareOnFacebook()"
                class="flex items-center justify-center w-7 h-7 sm:w-8 sm:h-8 bg-[#1877F2] hover:bg-[#0e6ae4] text-white rounded-full transition-all"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-3 w-3"
                  viewBox="0 0 320 512"
                >
                  <path
                    fill="currentColor"
                    d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
                  />
                </svg>
              </button>

              <button
                (click)="shareOnTwitter()"
                class="flex items-center justify-center w-7 h-7 sm:w-8 sm:h-8 bg-[#1DA1F2] hover:bg-[#0d8fd9] text-white rounded-full transition-all"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-3 w-3"
                  viewBox="0 0 512 512"
                >
                  <path
                    fill="currentColor"
                    d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
                  />
                </svg>
              </button>

              <button
                (click)="shareOnLinkedIn()"
                class="flex items-center justify-center w-7 h-7 sm:w-8 sm:h-8 bg-[#0A66C2] hover:bg-[#0958a8] text-white rounded-full transition-all"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-3 w-3"
                  viewBox="0 0 448 512"
                >
                  <path
                    fill="currentColor"
                    d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
                  />
                </svg>
              </button>
            </div>

            <p class="text-base font-semibold text-[#FF5858]">
              Launching Soon – Stay Excited!
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Compact Footer -->
    <div class="mt-auto py-4 px-4 text-center mb-4 md:mb-0">
      <div class="text-white text-xs sm:text-sm mb-2">
        © 2025 CleverDeals. All rights reserved.
      </div>
      <div class="flex flex-wrap justify-center gap-3 text-xxs sm:text-xs">
        <a routerLink="/about-us" class="text-white hover:underline"
          >About Clever Deals</a
        >
        <a routerLink="/terms-conditions" class="text-white hover:underline"
          >Terms and Conditions</a
        >
        <a routerLink="/privacy-policy" class="text-white hover:underline"
          >Privacy Policy</a
        >
      </div>
    </div>
  </div>
</div>
